"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWebSettings = exports.WebSettingsProvider = exports.WebSettingsContext = void 0;

var react_1 = __importDefault(require("react"));

exports.WebSettingsContext = react_1.default.createContext({});

function WebSettingsProvider(_ref) {
  var _ref$settings = _ref.settings,
      settings = _ref$settings === void 0 ? {} : _ref$settings,
      children = _ref.children;
  return react_1.default.createElement(exports.WebSettingsContext.Provider, {
    value: settings,
    children: children
  });
}

exports.WebSettingsProvider = WebSettingsProvider;

function useWebSettings() {
  return react_1.default.useContext(exports.WebSettingsContext);
}

exports.useWebSettings = useWebSettings;